<template>
  <fin-selectable-card
    v-on="$listeners.click ? {click: (e) => $emit('click', e)} : {}"
    v-bind="cardOptions"
  >
    <fin-data-loader overlay :resolver="resolver" :data-adapter="adapter" :params="{chartOptions}"
                     @input="change">
      <template #content>
        <v-card-title class="card-title font-weight-bold pb-0 align-start">{{ title }}</v-card-title>
        <v-card-text class="pt-0 align-start">
          <v-row>
            <v-col>
              <fin-chart2 :options="chartData"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5" class="align-content-start">
              <div class="currentValue">
                {{ currentValue | currencyRounded(valueSuffix, 2) }}
              </div>
              <div>
                <fin-time-ago :datetime="changeDate" :limit="86400000" class="changeDate"/>
              </div>
            </v-col>
            <v-col cols="7" class="align-content-start">
              <div class="currentValue">
              <fin-value-change
                class="valueChange "
                v-if="performance"
                :absolute="performance.absolute"
                :percent="hidePercentageChange ? null : performance.percent"
                :valueSuffix="valueSuffix"
              />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
    </fin-data-loader>
  </fin-selectable-card>
</template>

<script>
import FinSelectableCard from "@/components/common/Chart2/PerformanceCharts/SelectableCard"
import FinDataLoader from "@/components/common/DataLoader"
import FinValueChange from "@/components/common/Chart2/PerformanceCharts/ValueChange"
import FinChart2 from "@/components/common/Chart2/FinChart2"
import HighchartsCore from "highcharts"

function getY(point) {
  if (!point) {
    return 0
  }
  //TODO util
  if (Array.isArray(point)) {
    return point.length > 1 ? point[1] : 0
  }
  return point.curr || point.y || 0
}

export default {
  name: "FinMediumPerformanceChart",
  components: {FinSelectableCard, FinDataLoader, FinValueChange, FinChart2},
  data() {
    return {
      performance: null,
      selection: 0,
      chartData: null
    }
  },
  props: {
    title: {
      type: String
    },
    chartOptions: {
      type: [Object, Array, Function, Promise]
    },
    cardOptions: {
      type: Object
    },
    hidePercentageChange:{
      type: Boolean
    }
  },
  methods: {
    resolver() {
      return this.chartOptions
    },
    adapter(val) {
      if (val?.series?.length) {
        val = HighchartsCore.merge({}, val)
        val.series[0].events = {
          performance: (props) => {
            this.performance = props
          }
        }
      }
      return val
    },
    change(val) {
      this.chartData = val
    }
  },
  computed: {
    valueSuffix() {
      return this.chartData?.tooltip?.valueSuffix || ''
    },
    currentValue() {
      return getY(this.performance?.end)
    },
    changeDate() {
      return this.performance?.to ? new Date(this.performance.to) : null
    },
  }
}
</script>

<style scoped>
::v-deep .card-title {
  font-size: 1.2em !important;
  line-height: 1.25;
  height: 58px;
  overflow: hidden;
}
.currentValue{
  font-family: Gilroy;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: var(--night-blue);
}

.valueChange{
  font-family: Gilroy;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
}
</style>
